module.exports = __webpack_public_path__ + "img/card-media-slider.bedcd434.png";